import clsx from 'clsx';
import { AText, Box } from '@alf/uikit';
import { LocalizedLink } from '@namespace/i18n';
import { Image } from '@namespace/icons2';

import styles from './index.module.css';

export const ReCaptcha = ({ className = '' }) => {
  return (
    <Box gap="s" className={clsx(styles.wrapper, className)}>
      <Image name="footer/recaptcha" />
      <Box gap="xxs" direction="column" justify="around">
        <AText breed="B" size="xs" color="txt_color_4">
          Protected by reCAPTCHA
        </AText>
        <Box gap="xxs" align="center">
          <LocalizedLink
            target="_blank"
            to="https://policies.google.com/privacy"
          >
            <AText breed="R" size="s" color="txt_link">
              Privacy
            </AText>
          </LocalizedLink>
          <AText breed="R" size="s" color="txt_link">
            -
          </AText>
          <LocalizedLink target="_blank" to="https://policies.google.com/terms">
            <AText breed="R" size="s" color="txt_link">
              Service
            </AText>
          </LocalizedLink>
        </Box>
      </Box>
    </Box>
  );
};
